import { render, staticRenderFns } from "./Sigil.vue?vue&type=template&id=5ad2fbf2&scoped=true"
import script from "./Sigil.vue?vue&type=script&lang=js"
export * from "./Sigil.vue?vue&type=script&lang=js"
import style0 from "./Sigil.vue?vue&type=style&index=0&id=5ad2fbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2fbf2",
  null
  
)

export default component.exports